import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useOsList, useOsTransicao } from '../../hooks/useOs'
import styles from '../_shared/CrudPage.module.css'
import osStyles from './OrdensServicoPage.module.css'

const statusCor: Record<string, string> = {
  aberta: '#1565C0', atribuida: '#7B1FA2', em_execucao: '#F57C00',
  concluida: '#388E3C', aprovada: '#00897B', cancelada: '#616161',
}

const prioridadeCor: Record<string, string> = {
  normal: '#757575', alta: '#F57C00', urgente: '#D32F2F', emergencial: '#B71C1C',
}

function OsActions({ osId, status }: { osId: string; status: string }) {
  const { iniciar, concluir } = useOsTransicao(osId)
  return (
    <div className={osStyles.actions}>
      {(status === 'aberta' || status === 'atribuida') && (
        <button
          className={osStyles.actionBtn}
          style={{ color: '#F57C00', borderColor: '#F57C00' }}
          onClick={() => iniciar.mutate()}
          disabled={iniciar.isPending}
        >
          ▶ Iniciar
        </button>
      )}
      {status === 'em_execucao' && (
        <button
          className={osStyles.actionBtn}
          style={{ color: '#388E3C', borderColor: '#388E3C' }}
          onClick={() => concluir.mutate()}
          disabled={concluir.isPending}
        >
          ✓ Concluir
        </button>
      )}
    </div>
  )
}

export default function OrdensServicoPage() {
  const [filtroStatus, setFiltroStatus] = useState('')
  const [filtroPrioridade, setFiltroPrioridade] = useState('')

  const { data, isLoading } = useOsList({
    ...(filtroStatus ? { status: filtroStatus } : {}),
    ...(filtroPrioridade ? { prioridade: filtroPrioridade } : {}),
    ordering: '-aberta_em',
  })

  return (
    <div className={styles.page} data-testid="os-list">
      <header className={styles.header}>
        <h1 className={styles.title}>Ordens de Serviço</h1>
        <Link
          to="/ordens-servico/novo"
          data-testid="btn-criar-os"
          style={{
            padding: '0.5rem 1rem',
            background: '#1565C0',
            color: 'white',
            borderRadius: '4px',
            textDecoration: 'none',
            fontSize: '0.9rem',
          }}
        >
          + Nova OS
        </Link>
      </header>
      <div className={styles.toolbar}>
        <select
          className={styles.search}
          style={{ maxWidth: 180 }}
          value={filtroStatus}
          onChange={(e) => setFiltroStatus(e.target.value)}
          aria-label="Filtrar por status"
          data-testid="os-filtro-status"
        >
          <option value="">Todos os status</option>
          <option value="aberta">Aberta</option>
          <option value="atribuida">Atribuída</option>
          <option value="em_execucao">Em execução</option>
          <option value="concluida">Concluída</option>
          <option value="aprovada">Aprovada</option>
          <option value="cancelada">Cancelada</option>
        </select>
        <select
          className={styles.search}
          style={{ maxWidth: 160 }}
          value={filtroPrioridade}
          onChange={(e) => setFiltroPrioridade(e.target.value)}
          aria-label="Filtrar por prioridade"
          data-testid="os-filtro-prioridade"
        >
          <option value="">Todas prioridades</option>
          <option value="normal">Normal</option>
          <option value="alta">Alta</option>
          <option value="urgente">Urgente</option>
          <option value="emergencial">Emergencial</option>
        </select>
      </div>

      {isLoading ? (
        <div className={styles.loading}>Carregando...</div>
      ) : (
        <div className={osStyles.list}>
          {data?.results.map((os) => (
            <div key={os.id} className={osStyles.card}>
              <div className={osStyles.cardLeft}>
                <div className={osStyles.prioridadeBar} style={{ backgroundColor: prioridadeCor[os.prioridade] }} />
                <div className={osStyles.info}>
                  <strong className={osStyles.titulo}>{os.titulo}</strong>
                  <span className={osStyles.numero}>OS #{os.numero} • {(os.tipo ?? '').replace(/_/g, ' ')}</span>
                </div>
              </div>
              <div className={osStyles.cardRight}>
                <span className={osStyles.status} style={{ backgroundColor: (statusCor[os.status] ?? '#999') + '20', color: statusCor[os.status] ?? '#666' }}>
                  {(os.status ?? '').replace('_', ' ')}
                </span>
                <OsActions osId={os.id} status={os.status} />
                <a
                  href={`/ordens-servico/${os.id}`}
                  style={{
                    fontSize: '0.85rem',
                    color: '#1565C0',
                    textDecoration: 'none',
                    marginLeft: '0.5rem',
                  }}
                >
                  Detalhes →
                </a>
              </div>
            </div>
          ))}
          {data?.results.length === 0 && (
            <p className={styles.empty}>Nenhuma OS encontrada com esses filtros.</p>
          )}
        </div>
      )}
      {data && <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 12 }}>{data.count} OS encontradas</p>}
    </div>
  )
}
